export enum ECcmAssessmentAnswer {
  Yes = 'Yes',
  No = 'No',
  NA = 'N/A',
}
